<template>
  <div class="wrapper">

    <worker-filter></worker-filter>


    <div class="title">
    </div>

    <router-link to="/student-check-in">
      <button @click="selectSign" class="base-btn qiandao">
        签&nbsp;到
      </button>
    </router-link>
    <!-- <router-link to="/attendance">
      <button class="base-btn chuqin">
        出勤记录
      </button>
    </router-link> -->
    <router-link to="/student-list">
      <button class="base-btn huamingce">
        学员花名册
      </button>
    </router-link>
  </div>
</template>

<script>
  import WorkerFilter from '../components/WorkerFilter.vue';
  import { mapGetters } from 'vuex';
  export default{
    name: 'work',
    data() {
      return {
        title: '我的工作',
        lessons:''
      };
    },
    methods: {
      checkIn() {
        this.$router.push({
          path: '/student-check-in'
        });
      },
      studentList() {
        this.$router.push({
          path: '/student-list'
        });
      },
      //签到接口提前调用
      selectSign(){
        this.$store.dispatch('getAllSigninStudentList',{campusId:this.school.id,classId:this.grade.id,lessons:this.lessons});
      }
    },
    computed:{
      ...mapGetters({
        school: 'school',
        grade: 'grade',
      }),
    },
    components: {
      WorkerFilter
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .wrapper {
    padding-top: px2rem(48);
    width: 100%;
    .title {
      margin: px2rem(182) auto 0 auto;
      @include bg-img('../assets/img/teacher/work_title');
      height: px2rem(148);
      width: px2rem(582);
    }
    .base-btn {
      font-family: 'SXSLST';
      border: 0;
      @include bg-img('../assets/img/teacher/highlight');
      background-size: 100% 100%;
      display: block;
      margin: 0 auto;
      color: white;
      width: px2rem(359);
      height: px2rem(128);
      outline: 0;
      font-size: px2rem(50);
      @include text-shadow(2, 2, rgba(58, 35, 10, 0.4));
      &.qiandao {
        margin-top: px2rem(145);
      }

      &.chuqin {
        margin-top: px2rem(50);
      }

      &.huamingce {
        margin-top: px2rem(50);
      }
    }

  }
</style>



// WEBPACK FOOTER //
// Work.vue?bc092a94